import Header from "../Common/Header";
import Sidemenubar from "../Common/Sidemenubar";

const QuizSummary = ()=>{
    return (
        <>
        <div className="container-fluid" style={{backgroundColor:'ButtonShadow', userSelect:'none'}}>
            <div className="row">
                <div className="col-12">
                    <div className="row mb-2">
                        <div className="col text-center">Summary of Quiz Attempt</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <div className="table">
                                <table className="table table-responsive table-hovered">
                                    <thead className="table-active">
                                        <th>Question No.</th>
                                        <th>Status</th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Answered</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col text-center">
                            <button className="btn btn-outline-danger btn-sm">Return to Quiz</button>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col text-center">
                            <button className="btn btn-sm btn-primary">Submit All & Finish</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}
export default QuizSummary;